import { defineMessages } from 'utils/intl';

export default defineMessages({
  soon: 'W dostawie',
  inactive: 'Niedostępny',
  noneValue: 'Brak',
});
